import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiURL, fetchPurchase, fetchSupplierMaster } from "./API";
import ResetDate from "../images/resetdate.png";

class PurchaseReport extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      cmbType: "Date Wise Summary",
      cmbSupplier: "",
      chekNewpage: false,
    },
    types: [
      { type: "Date Wise Summary" },
      { type: "Date Wise Detail" },
      { type: "Date Wise Detail With Item" },
      { type: "Supplier wise Summary" },
      { type: "Supplier wise Detail" },
      { type: "Supplier wise Detail With Item" },
    ],
    suppliers: [],
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Purchase Report";
    this.props.setActiveMenu("PurchaseReport");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name === "cmbType") {
          if (
            this.state.formData.cmbType === "Date Wise Summary" ||
            this.state.formData.cmbType === "Date Wise Detail"
          ) {
            //#To hide the checkbox and set it's value = ""
            this.setState({
              formData: {
                ...this.state.formData,
                chekNewpage: false,
              },
            });
            // console.log("new page : " + this.state.formData.chekNewpage);
          } /* else {
                    //#To visible the checkbox
                } */
        } else if (
          e.target.name === "dtpFromDate" ||
          e.target.name === "dtpToDate"
        ) {
          this.setfrom_todate();
        }
      }
    );
  };

  handleOnCheckChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };
  //#endregion Handles

  //#region Function
  getCmbType4BE(ReportType) {
    if (ReportType === "Date Wise Summary") {
      return "PurchaseDateWiseSummary";
    } else if (ReportType === "Date Wise Detail") {
      return "PurchaseDateWiseDetail";
    } else if (ReportType === "Date Wise Detail With Item") {
      return "PurchaseDateWiseItemDetail";
    } else if (ReportType === "Supplier wise Summary") {
      return "PurchaseSupplierWiseSummary";
    } else if (ReportType === "Supplier wise Detail") {
      return "PurchaseSupplierWiseDetail";
    } else if (ReportType === "Supplier wise Detail With Item") {
      return "PurchaseSupplierWiseItemDetail";
    }
  }

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chekNewpage"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateFromToDate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (
      !isValidItem(this.state.types, "type", this.state.formData.cmbType)
    ) {
      this.props.toastErrorMsg("Select Valid Type", "cmbType");
    } else if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else if (
      this.state.formData.cmbSupplier.length > 0 &&
      !isValidItem(
        this.state.suppliers,
        "vac_supplier",
        this.state.formData.cmbSupplier
      )
    ) {
      this.props.toastErrorMsg("Select Valid Supplier", "cmbSupplier");
    } else {
      result = true;
    }
    return result;
  };

  reqDataForReport = (bolChkDataExist) => {
    return {
      Op: "PurchaseReport",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      ReportType: this.getCmbType4BE(this.state.formData.cmbType),
      dat_fromdate: this.state.formData.dtpFromDate,
      dat_todate: this.state.formData.dtpToDate,
      vac_supplier: this.state.formData.cmbSupplier,
      int_SupplierWisePage: this.state.formData.chekNewpage === true ? 1 : 0,
      bolChkDataExist: bolChkDataExist,
    };
  };

  openPurchaseReport = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();
      let reqData = this.reqDataForReport(true);
      fetchPurchase(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            let params = new URLSearchParams(reqData);
            let popupURL =
              apiURL + "purchaseentrydetail.php?" + params.toString();
            window.open(
              popupURL,
              "PurchaseReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "PurchaseReport",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      // window.location.reload();
      this.onFormLoad(reset);
      document.getElementById("dtpFromDate").focus();
    }
  };

  onFormLoad = (reset = false) => {
    const { fromdate, todate } = getlocalstoragedate("PurchaseReport");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        if (reset == false) {
          this.loadSupplierList();
          document.getElementById("cmbType").focus();
        }
      }
    );
  };

  loadSupplierList = () => {
    const reqData = {
      Op: "LoadSupplierDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchSupplierMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        let suppliers = res.data.supplierList;
        if (suppliers == []) {
          suppliers = [{ vac_supplier: "" }];
        }
        this.setState({ suppliers });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
  };
  //#endregion Function

  render() {
    return (
      <div>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Purchase Report</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbType"
              label="Type*"
              items={this.state.types}
              colID="type"
              value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpFromDate"
            />
          </Grid>
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="From Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              nextCtrlID="dtpToDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbSupplier"
              accountYear={localStorage.getItem("ACY")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbSupplier"
              label="Supplier"
              items={this.state.suppliers}
              colID="vac_supplier"
              width={300}
              value={this.state.formData.cmbSupplier}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              // nextCtrlID="chekNewpage"
              defaultAction={() => {
                this.trimFormData(() => {
                  this.openPurchaseReport();
                });
              }}
            />
          </Grid>
          <Grid item>
            {/* {this.state.formData.cmbType !== 'Date Wise Summary' && this.state.formData.cmbType !== 'Date Wise Detail' && ( */}
            <FormControlLabel
              control={
                <Checkbox
                  id="chekNewpage"
                  name="chekNewpage"
                  value={this.state.formData.chekNewpage}
                  checked={this.state.formData.chekNewpage}
                  //  handleOnChange={this.handleOnCheckChange}/>
                  onChange={this.handleOnCheckChange}
                  disabled={
                    this.state.formData.cmbType === "Date Wise Summary" ||
                    this.state.formData.cmbType === "Date Wise Detail" ||
                    this.state.formData.cmbType === "Date Wise Detail With Item"
                  }
                />
              }
              label="Supplier Wise New Page"
            />
            {/* )} */}
          </Grid>
          <Grid item>
            <CtBtn
              label="PDF"
              onClick={() => {
                this.trimFormData(() => {
                  this.openPurchaseReport();
                });
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PurchaseReport))));
